import { useQuery } from '@tanstack/react-query';
import { QUERY_KEYS } from '@/query/queryKeys';
import { cashService } from '../../services/cashService';

export const useGetRepaymentSchedule = params => {
  return useQuery({
    queryKey: [QUERY_KEYS.cash.repayment_schedule, params],
    refetchOnWindowFocus: false,
    queryFn: () =>
      cashService.repaymentSchedule(params).then(response => {
        const { status, data } = response;
        if (status === 200) {
          return data;
        }
        return null;
      }),
  });
};
